import { render, staticRenderFns } from "./projectModelManager.vue?vue&type=template&id=22edb5a4"
import script from "./projectModelManager.vue?vue&type=script&lang=js"
export * from "./projectModelManager.vue?vue&type=script&lang=js"
import style0 from "./projectModelManager.vue?vue&type=style&index=0&id=22edb5a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports